export default __webpack_public_path__ + "static/59288-fa2f920be1ecefc7bcc8fd99a412c0eb.jpg";